import { render, staticRenderFns } from "./FacturaForm.vue?vue&type=template&id=a4668fe2&scoped=true&"
import script from "./FacturaForm.vue?vue&type=script&lang=ts&"
export * from "./FacturaForm.vue?vue&type=script&lang=ts&"
import style0 from "./FacturaForm.vue?vue&type=style&index=0&id=a4668fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4668fe2",
  null
  
)

export default component.exports